'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$() {
  this.aH6 = null;
  this.aH7 = false;
  this.aH4 = null;
  this.aH5 = false;
  this.a8w = 0;
  this.aH2 = null;
  this.aH3 = false;
  $n_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ = this;
  this.a8w = ($m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$(), 0);
}
export { $c_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ as $c_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ };
$p = $c_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$;
/** @constructor */
function $h_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$() {
}
export { $h_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ as $h_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ };
$h_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$.prototype = $p;
$p.aso = (function() {
  if ((!this.aH7)) {
    this.aH6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeInt__given_Ordering_Type__s_math_Ordering(this);
    this.aH7 = true;
  }
  return this.aH6;
});
$p.asn = (function() {
  if ((!this.aH5)) {
    var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_kernel_Order$();
    this.aH4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_kernel_Order$$anon$9(this.aso(), this$1);
    this.aH5 = true;
  }
  return this.aH4;
});
$p.Au = (function() {
  if ((!this.aH3)) {
    this.aH2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_CirceKeyCodec$().bre(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$1) => {
      var _$1$1 = (_$1 | 0);
      var e$proxy1 = $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$().iu(_$1$1);
      if ((e$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy1.bj) + ")"));
      }
      if ((e$proxy1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return (e$proxy1.aI | 0);
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy1);
    })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$2) => {
      var _$2$1 = (_$2 | 0);
      $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$();
      return _$2$1;
    })));
    this.aH3 = true;
  }
  return this.aH2;
});
$p.bVB = (function(evidence$1) {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
  var keyToString$proxy2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((key) => {
    var key$1 = (key | 0);
    return $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$().Au().vK(key$1);
  }));
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$();
  var this$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_SchemaType$SOpenProduct($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$(), evidence$1, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$2) => _$2.ut(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
    if ((x$1 !== null)) {
      var k = (x$1.a0() | 0);
      var v = x$1.a3();
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), keyToString$proxy2.h(k), v);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
  })))))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$SName$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema$SName("Map", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("neotype.Newtype.Type", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon("app.data.app_document$package.AppDocumentVersion.schemaForNonEmptyMap.V", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$()))))), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), false), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Validator$().R), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_AttributeMap$().Q));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$2$2) => $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$().cr(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyMapOps(_$2$2).FN)));
  var schemaType$1 = this$16.ag.mp(g);
  var this$17 = this$16.bb;
  if (this$17.c()) {
    var default$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$17.g();
    matchResult4: {
      var default$1$1;
      if ((arg1 !== null)) {
        var t = arg1.a0();
        var raw = arg1.a3();
        var this$18 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_package$().ais.brc($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_SortedMap$().bqS(t, $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$().asn().oR()));
        var default$1$1 = (this$18.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), this$18.g(), raw)));
        break matchResult4;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arg1);
    }
  }
  var validator$1 = this$16.b8.rr(g);
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(schemaType$1, this$16.bg, this$16.bc, this$16.be, default$1$1, this$16.aj, this$16.bf, this$16.jL, this$16.b7, validator$1, this$16.b6);
});
$p.a5W = (function(v) {
  $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$();
  return ((1 + ($m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$(), v)) | 0);
});
var $d_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$, "app.data.app_document$package$AppDocumentVersion$", ({
  Ft: 1,
  B: 1,
  C: 1,
  Yk: 1
}));
export { $d_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ as $d_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ };
var $n_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$;
function $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$() {
  if ((!$n_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$)) {
    $n_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ = new $c_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$();
  }
  return $n_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$;
}
export { $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ as $m_Lapp_data_app\uff3fdocument$package$AppDocumentVersion$ };
//# sourceMappingURL=app.data.app_document$package$-App-Document-Version$.js.map
